function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgCloud = function SvgCloud(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480.247 480.247",
    style: {
      enableBackground: "new 0 0 480.247 480.247"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M426.208,157.755c-1.12,0-42.648,0-42.648,0c0.744-8.16,1.24-9.968,1.256-14.744 c0.128-42.672-28.36-80.592-70.032-89.776c-23.752-5.232-46.424-1.68-65.184,8.44c-22.888-34.064-60.808-57.2-104.272-59.856 c-5.592-0.768-11.256-1.304-17.056-1.304C57.432,0.515,0,59.739,0,132.803c0,38.072,15.688,72.288,40.648,96.424 c22.072,24.488,52.72,40.304,89.008,42.936c0,0,295.432,1.464,296.552,1.464c29.712,0,53.792-25.936,53.792-57.928 C480,183.691,455.912,157.755,426.208,157.755z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9F4F6"
    },
    d: "M249,441.067c12.68-21.96,10.224-48.496-4.104-67.552c-23.672-2.88-47.88,8.264-60.56,30.224 s-10.232,48.496,4.104,67.552C212.112,474.171,236.32,463.027,249,441.067z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M264.264,354.627c2.208-3.832,0.896-8.72-2.928-10.928s-8.72-0.896-10.928,2.928l-10.76,18.632 c-25.424-0.872-49.36,12.168-62.24,34.464c-13.928,24.128-12.104,54.104,4.64,76.368c1.312,1.736,3.272,2.864,5.424,3.128 c2.832,0.352,5.656,0.512,8.448,0.512c24.568,0,47.504-13.016,60.008-34.672c13.128-22.736,12.08-50.6-2.088-72.384L264.264,354.627 z M242.072,437.067c-10.136,17.552-29.144,27.648-49.224,26.584c-11.008-16.784-11.72-38.368-1.584-55.92 c8.368-14.496,22.816-23.8,38.896-26.04l-28.336,49.072c-2.208,3.832-0.896,8.72,2.928,10.928c1.264,0.728,2.64,1.072,3.992,1.072 c2.768,0,5.456-1.44,6.936-4l28.88-50.016C251.408,404.131,250.728,422.059,242.072,437.067z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9F4F6"
    },
    d: "M74.416,383.139c24.488-6.56,41.52-27.056,44.864-50.672c-14.704-18.776-39.704-28.016-64.192-21.448 c-24.488,6.56-41.52,27.056-44.864,50.672C24.928,380.467,49.92,389.699,74.416,383.139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M151.984,323.011c-1.144-4.272-5.528-6.832-9.8-5.656l-20.8,5.568 c-17.392-18.536-43.488-26.312-68.368-19.64c-26.904,7.208-46.816,29.688-50.72,57.272c-0.304,2.16,0.28,4.344,1.624,6.056 c13.368,17.08,33.576,26.624,54.568,26.624c5.984,0,12.024-0.776,18-2.376c25.368-6.8,44.336-27.232,49.712-52.664l20.128-5.392 C150.592,331.667,153.128,327.275,151.984,323.011z M72.344,375.411c-19.576,5.24-40.248-1.032-53.608-16.008 c4.08-19.656,18.84-35.416,38.424-40.664c16.16-4.32,33.016-0.704,45.936,9.088l-54.76,14.672c-4.272,1.144-6.8,5.528-5.656,9.8 c0.96,3.576,4.184,5.928,7.72,5.928c0.68,0,1.384-0.088,2.072-0.272l55.792-14.944C102.24,358.723,89.08,370.923,72.344,375.411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9F4F6"
    },
    d: "M408.064,423.139c-24.488-6.56-41.52-27.056-44.864-50.672 c14.704-18.776,39.704-28.016,64.192-21.448c24.488,6.56,41.52,27.056,44.864,50.672 C457.552,420.467,432.56,429.699,408.064,423.139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M429.464,343.283c-24.872-6.68-50.976,1.112-68.368,19.64l-20.808-5.576 c-4.256-1.144-8.656,1.4-9.8,5.656c-1.144,4.264,1.392,8.656,5.656,9.8l20.136,5.392c5.384,25.424,24.344,45.864,49.712,52.664 c5.968,1.6,12.008,2.376,17.992,2.376c20.984,0,41.192-9.544,54.56-26.624c1.344-1.712,1.928-3.896,1.624-6.056 C476.272,372.971,456.368,350.499,429.464,343.283z M410.144,415.411c-16.736-4.488-29.896-16.688-35.928-32.408L430,397.947 c0.696,0.184,1.392,0.272,2.08,0.272c3.528,0,6.768-2.36,7.72-5.928c1.144-4.264-1.392-8.656-5.656-9.8l-54.752-14.664 c12.928-9.792,29.792-13.408,45.928-9.088c19.576,5.248,34.344,21.008,38.424,40.664 C450.384,414.387,429.744,420.651,410.144,415.411z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloud, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cloud.cb7f1d95.svg";
export { ForwardRef as ReactComponent };